import React, { useState } from 'react';
import vidaImage from '../assets/medico.jpg';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import '../styles/disenosegurosbase.css';
import FamilyMembers from '../components/FamilyMembers';

export default function SeguroDeVida() {
  const [nombre, setNombre] = useState("");
  const [edad, setEdad] = useState("");
  const [genero, setGenero] = useState("");
  const [familyMembers, setFamilyMembers] = useState([]);
  const [ingresos, setIngresos] = useState("");
  const [correo, setCorreo] = useState("");
  const [numero, setNumero] = useState("");

  const navigate = useNavigate();
  const handleSubmit = async () => {
    if (!nombre || !edad || !genero || !ingresos || !correo || !numero) {
    Swal.fire('Campos incompletos', 'Por favor llena todos los campos obligatorios.', 'warning');
      return;
    }

    if (isNaN(edad) || edad <= 0 || edad > 99) {
      return;
    }

    if (!ingresos) {
      Swal.fire("Por favor selecciona tu rango de ingresos.");
      return;
    }
  // Validar correo
  const correoValido = /^[a-zA-Z0-9._%+-]+@(gmail|hotmail|outlook|yahoo)\.com$/;
  if (!correoValido.test(correo)) {
    Swal.fire("Por favor, ingresa un correo válido de @gmail.com, @hotmail.com, @outlook.com o @yahoo.com.");
    return;
  }

    try {
      console.log("JSON Personasextras:", familyMembers.length > 0 ? JSON.stringify(familyMembers) : '[]');

      const response = await fetch(`https://ricardodiaztuasesorfinanciero.com/api/citasegurovida`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Nombre: nombre,
          Edad: edad,
          Genero: genero,
          Personasextras: familyMembers.length > 0 ? JSON.stringify(familyMembers) : '[]',
          Ingresos: ingresos,
          Correo: correo,
          Numero: numero
        })
      });

      const result = await response.json();
      console.log(result);
      Swal.fire({
        title: "Gracias!Nos pondremos en contacto pronto!",
        icon: "success",
        draggable: true
      });
    } catch (error) {
      console.error("Error al enviar los datos", error);
      Swal.fire("Ocurrió un error al enviar los datos.");
    }
  };

  return (
    <>
      <button
        onClick={() => navigate('/')}
        className="seguro-back"
      >
        ← Regresar al Menú
      </button>
      <div className="seguro-container">
        <div className="seguro-left">
          <img src={vidaImage} alt="Seguro de vida" />
          <div className="seguro-overlay">
            <h1>Protege tu futuro y el de tu familia</h1>
            <p>
              Con nuestro seguro de vida, aseguras tranquilidad y respaldo para tus seres queridos.
              Completa el formulario para obtener tu cotización personalizada.
            </p>
          </div>
        </div>

        <div className="seguro-form">
          <h2>Cotización Seguro de Vida</h2>

        <label>Nombre:</label>
        <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)}  />

        <label>Edad:</label>
        <input
          type="number"
          value={edad}
          onChange={(e) => {
            const val = e.target.value;
            if (val === '' || (Number(val) >= 1 && Number(val) <= 99)) setEdad(val);
          }}
        />

        <label>Género:</label>
        <select value={genero} onChange={(e) => setGenero(e.target.value)} >
          <option value="">Selecciona</option>
          <option value="Masculino">Masculino</option>
          <option value="Femenino">Femenino</option>
        </select>

        <FamilyMembers 
          onFamilyChange={setFamilyMembers}
          initialFamily={familyMembers}
        />

        <label>Ingresos mensuales (aproximado):</label>
        <select value={ingresos} onChange={(e) => setIngresos(e.target.value)}>
          <option value="">Selecciona tu rango de ingresos</option>
          <option value="10,000 - 20,000">$10,000 - $20,000</option>
          <option value="20,000 - 30,000">$20,000 - $30,000</option>
          <option value="30,000 - 40,000">$30,000 - $40,000</option>
          <option value="40,000 - 50,000">$40,000 - $50,000</option>
          <option value="Más de 50,000">Más de $50,000</option>
        </select>

        <label>Correo electrónico:</label>
        <input type="email" value={correo} onChange={(e) => setCorreo(e.target.value)}  />

        <label>Número de teléfono:</label>
        <input type="tel" value={numero} onChange={(e) => setNumero(e.target.value)}  />

        <button onClick={handleSubmit} className="seguro-btn">Enviar</button>
        <p
          onClick={() => navigate("/pantallaCIT")}
          className="seguro-link"
        >
          ¿Quieres atencion mas directa? Agenda tu cita aquí!
        </p>
      </div>
    </div>
  </>
  );
}
